export const QUOTE_REQUESTED_TITLE = 'Your quote has been requested!';
export const QUOTE_REQUESTED_SUBTITLE = `We've received your request for a quote. You will be emailed with a quote in 48 hours.`;
export const ORDER_SUBMITTED_TITLE = 'Your order has been submitted!';
export const ORDER_SUBMITTED_SUBTITLE = `We've received your order. You will be notified via email of delivery details shortly.`;
